import { render, staticRenderFns } from "./VpAccountLedger.vue?vue&type=template&id=4fe132b4"
import script from "./VpAccountLedger.vue?vue&type=script&lang=js"
export * from "./VpAccountLedger.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports